import React from "react";
import { FaBatteryHalf, FaWifi, FaSatelliteDish } from "react-icons/fa";
import "./layout.css";

export default function DroneStreaming() {
  return (
    <div className="page-container">
      <h1 className="text-2xl font-bold mb-4">Drone Streaming</h1>

      {/* Video Stream Section */}
      <div className="bg-white shadow rounded-lg p-4 mb-6">
        <div className="relative w-full max-h-[780px] rounded overflow-hidden">
          <video
            src="/drone_video-output.mp4"
            autoPlay
            loop
            muted
            playsInline
            controls
            className="w-full h-[700px] object-cover rounded"
          />
          <div className="absolute top-2 right-2 text-white text-sm bg-black bg-opacity-50 px-2 py-1 rounded">
            Coordinates: -13.75, 24.17
          </div>
        </div>
      </div>

      {/* Drone Specifications Section */}
      <div className="flex flex-row gap-6">
        {/* Drone Image & Specs */}
        <div className="flex-1 bg-white shadow rounded-lg p-4 flex flex-col items-center">
          <img
            src="/DJI_Mavic-3-Classic_cover-3.jpg"
            alt="Drone"
            className="w-40 h-32 object-contain mb-4"
          />
          <div className="text-left w-full space-y-2">
            <p><strong>Drone Model:</strong> DJI Avata 2</p>
            <p><strong>Battery Capacity:</strong> 2150 mAh</p>
            <p><strong>Storage Capacity:</strong> 32 GB</p>
            <p><strong>Flying Speed:</strong> 21 km/h</p>
            <p><strong>Aerial Coverage:</strong> 13 km²</p>
          </div>
        </div>

        {/* Drone Manual (Thumbnail + Download) */}
        <div className="flex-1 bg-white shadow rounded-lg p-4 flex flex-col items-center text-center">
          <h3 className="text-lg font-semibold mb-3">Drone Manual</h3>
          <img
            src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
            alt="PDF Icon"
            className="w-16 h-16 mb-2"
          />
          <p className="text-sm text-gray-700 mb-3">
            DJI_Avata_2_User_Manual_v1.0_en.pdf
          </p>
          <a
            href="/DJI_Avata_2_User_Manual_v1.0_en.pdf"
            download
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Download Manual
          </a>
        </div>

        {/* Drone Status Info (Hardcoded) */}
        <div className="flex-1 bg-white shadow rounded-lg p-4 flex flex-col gap-3">
          <h3 className="text-lg font-semibold text-center">Live Drone Status</h3>
          <div className="flex items-center gap-3 text-gray-700">
            <FaBatteryHalf className="text-green-600 text-xl" />
            <span><strong>Battery:</strong> 76%</span>
          </div>
          <div className="flex items-center gap-3 text-gray-700">
            <FaWifi className="text-blue-500 text-xl" />
            <span><strong>Signal:</strong> Strong</span>
          </div>
          <div className="flex items-center gap-3 text-gray-700">
            <FaSatelliteDish className="text-purple-600 text-xl" />
            <span><strong>Status:</strong> Hovering</span>
          </div>
        </div>
      </div>
    </div>
  );
}
